import { SuperAdminConstants } from '../../../_constants';

const initialState = { analyticsDefaultMetricListLoading: true, data: '', error: false };

export function analyticsDefaultMetricListReducer(state = initialState, action) {
    
    switch (action.type) {
        case SuperAdminConstants.REQUEST_ANALYTICS_DEFAULT_METRIC_LIST:
            return {
                analyticsDefaultMetricListLoading: true,
                data: '',
                error: false
            };
        case SuperAdminConstants.RECEIVE_ANALYTICS_DEFAULT_METRIC_LIST:
            return {
                analyticsDefaultMetricListLoading: false,
                data: action,
                error: false
            };
        case SuperAdminConstants.ANALYTICS_DEFAULT_METRIC_LIST_ERROR:
            return {
                analyticsDefaultMetricListLoading: false,
                data: '',
                error: true
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/SuperAdmin/AssignMetric/getDropdownListMetric.reducer.js